import { useNavigate } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { SignupPage } from "@/features/user/pages/SignupPage";
import { Button } from "@/shared/components/shadcn/Button";
import { Page, PageContent, PageFooter } from "@/shared/components/ui/Page";
import { SetupHeader } from "@/shared/components/ui/SetupHeader";
import { WelcomeIntro } from "../components/WelcomeIntro";

export function WelcomePage({ onStart }: { onStart?: () => void }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const handleStart = () => {
    if (loading) return;
    if (onStart) {
      onStart();
    } else {
      navigate("/?setup=start");
    }
  };

  if (!user) return <SignupPage />;

  return (
    <div className={onStart ? "h-dvh" : "h-full min-h-0"}>
      <Page>
        <SetupHeader title="Welcome" titleSize="welcome" centered />
        <PageContent className="flex flex-col overflow-y-hidden [scrollbar-gutter:auto]">
          <WelcomeIntro />
        </PageContent>
        <PageFooter narrow>
          <Button size="touch" disabled={loading} onClick={handleStart}>Let's get started</Button>
        </PageFooter>
      </Page>
    </div>
  );
}
